import React, { useEffect, useState } from 'react'
import Input from "../../../../../../core/Inputs/DefaultInput";
import { useDispatch, useSelector } from 'react-redux';
import { changeAddSurveyFormData } from '../../../../../../store/actions/surveyAction';
import { useTranslation } from 'react-i18next';

export default function QuestionScreen5({ changeScreen }) {
    const { t, i18n } = useTranslation();
    //States
    const formData = useSelector((state) => state.surveyData?.addSurveyFormData)
    const sectionCount = formData?.survey_section_count

    const dispatch = useDispatch()

    let initialValues = Array.from({ length: sectionCount })
    initialValues = initialValues?.map((_, index) => {
        return {
            section_description: '',
            question_number: '',
            section_text: '',
        }
    })
    let initialErrors = initialValues?.map((_, index) => {
        return {
            question_number: false,
            section_text: false,
        }
    })
    const [sectionData, setSectionData] = useState(initialValues)
    const [sectionError, setSectionError] = useState(initialErrors)

    //Functionality
    const onSubmit = () => {
        let isValid = true
        let errors = [...sectionError]
        sectionData?.forEach((section, index) => {
            // if (section.question_number === '') {
            //     errors[index]['question_number'] = true
            //     isValid = false
            // } else {
            //     errors[index]['question_number'] = false
            // }
            if (section.section_text === '') {
                errors[index]['section_text'] = true
                isValid = false
            } else {
                errors[index]['section_text'] = false
            }
        })
        if (!isValid) {
            setSectionError(errors)
            return
        } else {
            setSectionError(initialErrors)
        }

        dispatch(changeAddSurveyFormData('survey_section_data', sectionData))
        changeScreen('INCREMENT')
    }

    const onChangeInput = (index, key, vlaue) => {
        setSectionData((old) => {
            let data = [...old]
            data[index][key] = vlaue
            return data
        })
    }

    // const isQuestionNumberValid = (index) => {
    //     if (sectionData[index].question_number === '') {
    //         setSectionError((old) => {
    //             let tmp = [...old]
    //             tmp[index].question_number = true
    //             return tmp
    //         })
    //         return
    //     }
    //     setSectionError((old) => {
    //         let tmp = [...old]
    //         tmp[index].question_number = false
    //         return tmp
    //     })
    // }

    const isSectionNameValid = (index) => {
        if (sectionData[index].section_text === '') {
            setSectionError((old) => {
                let tmp = [...old]
                tmp[index].section_text = true
                return tmp
            })
            return
        }
        setSectionError((old) => {
            let tmp = [...old]
            tmp[index].section_text = false
            return tmp
        })
    }

    return (
        <div className="new-survery-screen text-center">
            <div className="surv-question-wrap">
                <div className="text-wrapper">
                    {/* <h2 className="question">Provide your section names & number of questions in each</h2> */}
                    <h2 className="question">{t('survey.ques5')}</h2>
                    <div className="input-wrap mb-5">

                        <div className="section-number-title d-flex">
                            <div className="section-name flex-grow-1">{t('survey.ques6')}</div>
                            {/* <div className="number">No. of questions</div> */}
                        </div>
                        <div className="section-number-outer-wrapper">
                            {
                                Array.from({ length: sectionCount }).map((_, index) => {

                                    return (
                                        <div className="section-number-wrapper d-flex" key={index}>
                                            <div className="section-name flex-grow-1">
                                                <div className="input-wrapper">
                                                    <div className="text-wrapper position-relative">
                                                        < Input
                                                            type='text'
                                                            view='outlined'
                                                            dense={false}
                                                            color='default'
                                                            label=''
                                                            placeholder={t('survey.ques6')}
                                                            success={false}
                                                            fill={true}
                                                            value=""
                                                            className={"formsinput font-bold"}
                                                            onBlur={() => isSectionNameValid(index)}
                                                            onInput={(e) => onChangeInput(index, 'section_text', e.target.value)}
                                                        />
                                                        {sectionError[index]['section_text'] && <div className="validation-msg">{t('survey.SectionRequired')}</div>}
                                                    </div>
                                                    <div className="text-wrapper">
                                                        <textarea
                                                            className="form-control"
                                                            rows="3"
                                                            placeholder={t('survey.builder.add_description')}
                                                            value={sectionData[index]['section_description']}
                                                            onChange={(e) => onChangeInput(index, 'section_description', e.target.value)}
                                                        ></textarea>
                                                    </div>
                                                </div>
                                            </div>
                                            {/* <div className="number-wrapper">
                                                <div className="input-wrapper">
                                                    <div className="text-wrapper position-relative">
                                                        < Input
                                                            type='text'
                                                            view='outlined'
                                                            dense={false}
                                                            color='default'
                                                            label=''
                                                            success={false}
                                                            fill={true}
                                                            value=""
                                                            className={"formsinput"}
                                                            onBlur={() => isQuestionNumberValid(index)}
                                                            onInput={(e) => onChangeInput(index, 'question_number', e.target.value)}
                                                        />
                                                        {sectionError[index]['question_number'] && <div className="validation-msg">Required</div>}
                                                    </div>
                                                </div>
                                            </div> */}
                                        </div>
                                    )
                                })
                            }

                        </div>

                        {/* <div className="add-section">
                            <a href="#" className='add-btn d-flex align-items-center'>
                                <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"> <rect x={16} y={16} width={16} height={16} rx={8} transform="rotate(180 16 16)" fill="#2773FF" /> <path d="M8 3V13" stroke="white" strokeWidth="1.5" /> <path d="M13 8L3 8" stroke="white" strokeWidth="1.5" /> </svg> Add option
                            </a>
                        </div> */}

                    </div>
                    <button className='btn btn-primary next-btn' onClick={() => onSubmit()}>{t('survey.question.next')}</button>
                </div>
            </div>
        </div>
    )
}
